import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import useHighlight from '../../../../hooks/useHighlight.js';
import PillStatus from '../../../PillStatus/PillStatus.js';

const defaultStatuses = [
    { key: 'archived', props: { type: 'no-border', label: 'archived' } },
    { key: 'operational', props: { scheme: 'green', label: 'operational' } },
    { key: 'in progress', props: { scheme: 'blue', label: 'in progress' } },
    { key: 'pending', props: { scheme: 'gray', label: 'pending' } },
    { key: 'only me', props: { scheme: 'blue', label: 'only me' } },
    { key: 'read only', props: { scheme: 'red', label: 'read only' } },
    { key: 'everyone', props: { scheme: 'gray', label: 'everyone' } },
];
const Status = React__default.memo(({ value, statuses, state }) => {
    const markText = useHighlight(state === null || state === void 0 ? void 0 : state.globalFilter);
    if (!value || value === 'no status') {
        return null;
    }
    const status = (statuses || defaultStatuses).find(({ key }) => key === value);
    return jsx(PillStatus, Object.assign({}, status === null || status === void 0 ? void 0 : status.props, { label: markText(value) }));
});
Status.displayName = 'Status';

export { Status as default };
//# sourceMappingURL=Status.js.map
